import { Lightbulb, Handshake, TrendingUp } from "lucide-react";

const About = () => {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold mb-6 text-center">About Karinfinity</h2>
          <p className="text-lg text-gray-600 mb-10 text-center">
            We are a team of data scientists, engineers, and consultants passionate about helping 
            businesses harness the power of their data.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-16">
            <div>
              <h3 className="text-2xl font-bold mb-4">Our Mission</h3>
              <p className="text-gray-600">
                To empower organizations to make better decisions through data-driven insights and 
                innovative AI solutions, enabling them to stay ahead in the rapidly evolving digital landscape.
              </p>
            </div>
            <div>
              <h3 className="text-2xl font-bold mb-4">Our Vision</h3>
              <p className="text-gray-600">
                To be the leading partner for businesses seeking to transform their operations through 
                advanced analytics and artificial intelligence, creating measurable value and sustainable growth.
              </p>
            </div>
          </div>
          
          <div className="bg-white p-8 rounded-lg shadow-md">
            <h3 className="text-2xl font-bold mb-6 text-center">Our Values</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Lightbulb className="h-6 w-6 text-blue-600" />
                </div>
                <h4 className="font-bold text-lg mb-2">Innovation</h4>
                <p className="text-gray-600">Constantly exploring new methods and technologies to deliver cutting-edge solutions</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Handshake className="h-6 w-6 text-blue-600" />
                </div>
                <h4 className="font-bold text-lg mb-2">Partnership</h4>
                <p className="text-gray-600">Building long-term relationships based on trust, transparency, and mutual success</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <TrendingUp className="h-6 w-6 text-blue-600" />
                </div>
                <h4 className="font-bold text-lg mb-2">Results</h4>
                <p className="text-gray-600">Focusing on measurable outcomes that deliver real business value</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
